import mongoose from "mongoose";

export interface Report {
  _id: mongoose.Schema.Types.ObjectId;
  userId: string;
  reportType: string;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  params: any;
  status: string;
  error: string;
  resultS3Bucket: string;
  resultS3Key: string;
  createdAt: Date;
}

export const ReportSchema = new mongoose.Schema<Report>({
  userId: String,
  reportType: String,
  params: mongoose.Schema.Types.Mixed,
  status: String,
  error: String,
  resultS3Bucket: String,
  resultS3Key: String,
  createdAt: { type: Date, expires: 7200, default: Date.now },
});
